<template>
  <div >
    <div class="demo-upload-list" v-for="item in uploadList" :style="uploadStyle">
      <template v-if="item.status === 'finished'">
        <img v-if="type === 'video'" :src="item.thumbUrl">
        <img v-else-if="type === 'file'" :src="require('../assets/images/icon_file.png')">
        <img v-else :src="item.url">
        <div class="demo-upload-list-cover">
          <Icon v-if="type !== 'file'" type="ios-eye-outline" @click.native="handleView(item)"></Icon>
          <Icon v-if="type == 'file'" type="ios-download-outline" @click.native="handleDownload(item)"></Icon>
          <Icon type="ios-trash-outline" @click.native="handleRemove(item)"></Icon>
        </div>
      </template>
      <template v-else>
        <Progress v-if="item.showProgress" :percent="item.percentage" hide-info></Progress>
      </template>
    </div>
    <Upload v-show="limit ? uploadList.length < limit : true"
      ref="upload"
      :show-upload-list="false"
      :default-file-list="defaultList"
      :on-success="handleSuccess"
      :format="format"
      :max-size="maxSize"
      :on-format-error="handleFormatError"
      :on-exceeded-size="handleMaxSize"
      :before-upload="handleBeforeUpload"
      :multiple="multiple"
      :headers="{xc_sso_sessionid:xc_sso_sessionid}"
      type="drag"
      :action="uploadUrl"
      style="display: inline-block;width:58px;">
      <div style="width: 58px;height:58px;line-height: 58px;">
        <Icon type="ios-camera" size="20"></Icon>
      </div>
    </Upload>
  </div>
</template>
<script type="text/jsx">
  import * as Cache from "../cache/Cache";
  import Constant from "../constant/index";
  export default {
    props: [
      "limit", //上传最大数量
      "maxSize", //文件限制大小 传1024表示1M
      "onUploadSuccess",
      "type",
      "uploadStyle",
      "value",
      "multiple"
    ],
    created(){
      let type;
      if(this.type) {
        type = this.type;
      } else {
        type = 'image'
      }

      if(type === 'video') {
        this.format = ['mp4'];
      } else if(type === 'image'){
        this.format = ['jpg','jpeg','png'];
      }
    },
    data () {
      return {
        xc_sso_sessionid: Cache.getSsoSession(),
        uploadList: [],
        defaultList: [],
        format:[],
        imgName: '',
        visible: false,
      }
    },
    computed: {
      uploadUrl() {
        let url = Constant.UPLOAD_URL;
        return url;
      },
    },
    watch: {
      value(val) {
        if(val) {
          if(Object.prototype.toString.call(val)=='[object Array]') {

          } else {
            let fileList = [{url: val}];
            this.setFileList(fileList);
          }
        } else {
          this.clearAll();
        }
      },
    },
    methods: {
      onChange(){
        let imageList = [];
        this.uploadList.map(data => {
          imageList.push(data.url);
        })
        this.$emit('input',imageList.join(','));
      },
      handleView (file) {
        this.imgName = file.name ? file.name : '';

        if(this.type === 'video') {
          this.$Modal.confirm({
            render: (h) => {
              return h('video', {
                domProps: {
                  src: file.url,
                  controls:true,
                  style: "height:700px;",
                },
              })
            },
          })
        } else {
          this.$Modal.confirm({
            width: 50,
            render: (h) => {
              return h('img', {
                domProps: {
                  src: file.url,
                  style: "width:100%",
                },
              })
            },
          })
        }

      },
      handleRemove (file) {
        const fileList = this.$refs.upload.fileList;
        this.$refs.upload.fileList.splice(fileList.indexOf(file), 1);
        this.onChange();
      },
      handleDownload(item){
        window.open(item.url)
      },
      handleSuccess (res, file) {
        if (res.code == 200) {
          let image = res.result;
          image.status = "finished";
          file.url = image.path;
          file.thumbUrl = image.thumbPath;
          file.id = image.id;
          file.name = image.originalName;
          if(this.onUploadSuccess) {
            this.onUploadSuccess(this.uploadList);
          }
          this.onChange();
        }
      },
      handleFormatError (file) {
        let formats = this.format.join('、')
        this.$Notice.warning({
          title: '文件类型错误',
          desc: `文件上传类型支持:${formats}`
        });
      },
      handleMaxSize (file) {
        this.$Notice.warning({
          title: '文件大小限制',
          desc: `文件最大支持${this.maxSize / 1024}M`
        });
      },
      handleBeforeUpload () {
        const check = this.uploadList.length < 5;
        if (!check) {
          this.$Notice.warning({
            title: 'Up to five pictures can be uploaded.'
          });
        }
        return check;
      },
      getFileList(){
        return this.uploadList;
      },
      setFileList(fileList){
        this.clearAll();

        fileList.forEach(data =>{
          data.status = 'finished';
        })
        this.uploadList.push(...fileList);
      },
      clearAll(){
        this.uploadList.splice(0,this.uploadList.length);
      }
    },
    mounted () {
      this.uploadList = this.$refs.upload.fileList;
    }
  }
</script>
<style>
  .demo-upload-list{
    width: 60px;
    height: 60px;
    text-align: center;
    border: 1px solid transparent;
    vertical-align: middle;
    border-radius: 4px;
    overflow: hidden;
    background: #fff;
    position: relative;
    box-shadow: 0 1px 1px rgba(0,0,0,.2);
    margin-right: 4px;
    float:left;
  }
  .demo-upload-list img{
    width: 100%;
    height: 100%;
  }
  .demo-upload-list-cover{
    display: none;
    align-items: center;
    justify-content: center;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(0,0,0,.6);
  }
  .demo-upload-list:hover .demo-upload-list-cover{
    display: flex;
  }
  .demo-upload-list-cover i{
    color: #fff;
    font-size: 20px;
    cursor: pointer;
    margin: 0 2px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Upload.vue